import { render, staticRenderFns } from "./WidgetLoading.vue?vue&type=template&id=5f8092cb"
import script from "./WidgetLoading.vue?vue&type=script&lang=js"
export * from "./WidgetLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports